import React from 'react';
import style from './index.module.css';
import MyFooter from '../../components/MyFooter';
import { Link } from 'react-router-dom';
import Card from '../../components/Card';
import DetailsCard from '../../components/DetailsCard';
import { eventList, detailedEventList } from '../../assets/constants';
import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';

const getServices = (excludeServices) => {
	var services = [];
	for (var i = 0; i < eventList.length; i++) {
		if (!excludeServices.includes(eventList[i].header)) {
			services.push(eventList[i]);
		}
	}
	return services;
};

const staggerContainer = {
	animate: {
		transition: {
			staggerChildren: 0.1
		}
	}
};

const itemVariants = {
	initial: { opacity: 0, y: 30 },
	animate: { opacity: 1, y: 0, transition: { duration: 0.5 } }
};

const OurServices = () => {
	const theme = useTheme();
	const isDark = theme.palette.mode === 'dark';

	var excludeServices = [
		'Decoration & Tenting',
		'Floral Decorations',
		'Lighting Arrangements',
		'Live Concerts',
		'Entertainment Nights',
		'Birthday Parties',
		'Corporate Events',
	];

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			style={{
				width: '100%',
				minHeight: '100vh',
				backgroundColor: theme.palette.background.default,
				color: theme.palette.text.primary,
			}}
		>
			{/* Details List */}
			<div className={style.detailsSection}>
				<div className={style.sectionHeader}>
					<p style={{ color: theme.palette.primary.main }}>PREMIUM PACKAGES</p>
					<h1>Our Core Services</h1>
				</div>
				<motion.div 
					variants={staggerContainer}
					initial="initial"
					whileInView="animate"
					viewport={{ once: true }}
					className={style.detailsList}
				>
						{detailedEventList.map((item, index) => {
							return (
								<motion.div 
									key={index} 
									variants={itemVariants}
									whileHover={{ scale: 1.02 }}
									style={{ cursor: 'pointer' }}
								>
									<Link to={`/our_services/${item.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
										<DetailsCard
											header={item.header}
											content={item.content}
											icon={item.icon}
										/>
									</Link>
								</motion.div>
							);
						})}
				</motion.div>
			</div>

			{/* Services List */}
			<div className={style.otherServicesSection} style={{ backgroundColor: isDark ? 'rgba(0,0,0,0.2)' : '#f9f9f9' }}>
				<div className={style.container}>
					<div className={style.sectionHeader}>
						<p style={{ color: theme.palette.primary.main }}>MORE OPTIONS</p>
						<h1>Other Specialized Services</h1>
					</div>
					<motion.div 
						variants={staggerContainer}
						initial="initial"
						whileInView="animate"
						viewport={{ once: true }}
						className={style.eventListStyle}
					>
						{getServices(excludeServices).map((item, index) => {
							return (
								<motion.div key={index} variants={itemVariants}>
									<Card
										header={item.header}
										content={item.content}
										icon={item.icon}
									/>
								</motion.div>
							);
						})}
					</motion.div>
				</div>
			</div>

			{/* Footer Section */}
			<MyFooter />
		</motion.div>
	);
};

export default OurServices;
